import React, { Component } from 'react';
import { Container, Popover, Button, TextField, Box, Typography } from '@material-ui/core'
import Autocomplete from '@material-ui/lab/Autocomplete';

export class FeeSelectPopover extends Component {

    styles = {
        button: {
            marginLeft: 10,
            marginRight: 10
        },
        container: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: 20,
            marginBottom: 10
        }
    };

 
    _okCallback;
    _cancelCallback;
    _defaultCallback;

    state = {
        fee: null,
        feeValue: null
    }
    
    constructor(props) {
        super(props);
        this._okCallback = props.okCallback;
        this._cancelCallback = props.cancelCallback;
        this._defaultCallback = props.defaultCallback;
    }
   
    
    
    _okButtonPressed = () => {
        this.setState({fee: null, feeValue: null});
        this._okCallback(this.state.fee);
    }

    _cancelButtonPressed = () => {
        this.setState({fee: null, feeValue: null});
        this._cancelCallback();
    }

    _defaultButtonPressed = () => {
        this.setState({fee: null, feeValue: null});
        this._defaultCallback();
    }
    
    
    render() {
        
        let maxWidth = window.innerWidth * 0.5;  //half the window, up to 700
        if (maxWidth > 700)
            maxWidth = 700;
        
        let selectTitle = "Select Fee for ";
        if (this.props.feeType)
            selectTitle += this.props.feeType.label;
        
        return (
            <Popover open={this.props.isOpen} 
                anchorReference="anchorPosition"
                anchorPosition={{left: window.innerWidth/2, top: window.innerHeight/2}}
                transformOrigin={{vertical: 'center', horizontal: 'center'}}  >
                
                <Box style={{margin: 20, width: maxWidth}}>
                    <Typography variant="subtitle1" style={{fontWeight: 'bold'}}>{selectTitle}</Typography>  
                    <div style={{marginTop: 20}}/>

                    <Autocomplete
                        size='small'
                        value={this.state.fee}
                        getOptionLabel={(fee) => fee.name }
                        onChange={(event, newValue) => { this.setState({fee: newValue}); }}
                        inputValue={this.state.feeValue}
                        onInputChange={(event, newValue) => { this.setState({feeValue: newValue}); }}
                        options={this.props.availableFees}
                        blurOnSelect
                        renderInput={(params) => <TextField {...params} label="Fees" variant="outlined" InputLabelProps={{ shrink: true }} />}
                    /> 

                    <Container style={this.styles.container}>    
                        <Button onClick={this._okButtonPressed} disabled={!this.state.fee} color="primary" variant="outlined" style={this.styles.button}>OK</Button>
                        <Button onClick={this._cancelButtonPressed} variant="outlined" style={this.styles.button}>Cancel</Button>
                        <Button onClick={this._defaultButtonPressed} variant="outlined" style={this.styles.button}>Use Default</Button>
                    </Container>
                </Box>
            </Popover>
        );
        
        
    }


}